import { mapGetters } from "vuex"

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    title:{
      type: String,
      default: 'SinTitulo'
    },
    indice:{},
    campo:{
      type: String,
      default: ''
    },
    inner:{
      type: String,
      default: ''
    },
    bSubdominioTemporal:{ //Indica que se activa puente con subdominio temporal
      type: Boolean,
      default: false
    }
  },
  mounted(){

    // Como llega "0 = '165'" es decir un selector de opcion y su valor separados por un blanco
    // Busco el primer blanco y valido que caracter es 

    let aux_ValorOpcion  = '' 
    let aux_ValorOpcion2 = ''
    const regexFechaFormat = /^\d{4}\-\d{2}\-\d{2}/ // eslint-disable-line

    if(this.value != ''){
      // el siguente codigo esta sugeto a mejora por el momento no encontre una mejor forma.
      if(this.value.includes('=')){
        this.selectOpcion = '=' 
        aux_ValorOpcion = this.value.slice(2,this.value.length)

      }
      if(this.value.includes('>=')){
        this.selectOpcion = '>=' 
        aux_ValorOpcion = this.value.slice(3,this.value.length)
      }
      if(this.value.includes('<=')){
        this.selectOpcion = '<=' 
        aux_ValorOpcion = this.value.slice(3,this.value.length)
      }
      if(this.value.includes('LIKE')){
        this.selectOpcion = 'LIKE' 
        aux_ValorOpcion = this.value.slice(5,this.value.length)
        aux_ValorOpcion = aux_ValorOpcion.replaceAll('^', '')
      }
      if(this.value.includes('between')){
        this.selectOpcion = 'between' 
        aux_ValorOpcion = this.value.slice(8,this.value.length)
        // como aqui hay dos valores hago un split por AND y obtengo los dos valores
        const aRango =  aux_ValorOpcion.replaceAll("'", '').trim().split('AND')
        aux_ValorOpcion  = aRango[0].trim()
        aux_ValorOpcion2 = aRango[1].trim()
        
        // valido si son fechas
        if(aux_ValorOpcion.match(regexFechaFormat)){

          aux_ValorOpcion  = aux_ValorOpcion.includes('00:00:00') ? aux_ValorOpcion.slice(0,10) : aux_ValorOpcion 
          aux_ValorOpcion2 = aux_ValorOpcion2.includes('23:59:59') ? aux_ValorOpcion2.slice(0,10) : aux_ValorOpcion2 

          if( aux_ValorOpcion === aux_ValorOpcion2){
            // llego una fecha igual 
            this.selectOpcion = '='
            this.FechaSelect = aux_ValorOpcion
          } else {
            // un verdadero between
            this.FechaRange = [aux_ValorOpcion, aux_ValorOpcion2]
            this.FechaSelect = null
          }
          
        }  
        
      }

      this.valorConsulta =  aux_ValorOpcion.replaceAll("'", '').trim()   
      this.valorConsulta2 = aux_ValorOpcion2  

      
    }
  },
  methods: {
    remove() {
      this.$emit('remove',this.indice)
      this.valorConsulta = ''
    },
    onAddInfoFiltro (sCampo, sPropiedad, sValor){
      let auxObje = {}
      auxObje.Titulo = sPropiedad
      auxObje.Valor = sValor
      auxObje.Campo = sCampo
      this.$store.dispatch('filterSeccion/save_aInfoFiltrada', auxObje)
    }
  },
  watch : {
    indice () {
      if(!this.getbCargarStorage) this.valorConsulta = ''
    }
  }, 
  computed: {
    ...mapGetters('filterSeccion', ['getbCargarStorage'])
  }, 

}